import { render } from "./input-birthdate.vue?vue&type=template&id=10e6d14c"
import script from "./input-birthdate.js?vue&type=script&lang=js&external"
export * from "./input-birthdate.js?vue&type=script&lang=js&external"

import "./input-birthdate.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__